import { PATHS } from '../../../enums/PATHS';
import { ROLES } from '../../../enums/ROLES';

export type TSidebarMenu = {
  label: string;
  exact: boolean;
  path: string;
  roles: ROLES[];
};

export const SIDEBAR_MENU: TSidebarMenu[] = [
  {
    label: PATHS.COLLABORATIVE_FOLDERS.label,
    exact: PATHS.COLLABORATIVE_FOLDERS.exact,
    path: PATHS.COLLABORATIVE_FOLDERS.path,
    roles: [ROLES.ANALYST, ROLES.ORGANIZATION_ADMIN],
  },
  // {
  //   label: PATHS.ALL_CONTENT.label,
  //   exact: PATHS.ALL_CONTENT.exact,
  //   path: PATHS.ALL_CONTENT.path,
  //   roles: [ROLES.ORGANIZATION_ADMIN],
  // },
  {
    label: PATHS.SHARED_WITH_ME.label,
    exact: PATHS.SHARED_WITH_ME.exact,
    path: PATHS.SHARED_WITH_ME.path,
    roles: [ROLES.ANALYST, ROLES.ORGANIZATION_ADMIN, ROLES.VIEWER],
  },
  {
    label: PATHS.MY_REFLEX_COMPOSERS.label,
    exact: PATHS.MY_REFLEX_COMPOSERS.exact,
    path: PATHS.MY_REFLEX_COMPOSERS.path,
    roles: [ROLES.ANALYST, ROLES.ORGANIZATION_ADMIN, ROLES.VIEWER],
  },
  {
    label: PATHS.MY_FOLDERS.label,
    exact: PATHS.MY_FOLDERS.exact,
    path: PATHS.MY_FOLDERS.path,
    roles: [ROLES.ANALYST, ROLES.ORGANIZATION_ADMIN],
  },
];

export const PARENT_ORG_SIDEBAR_MENU: TSidebarMenu[] = [
  {
    label: PATHS.COLLABORATIVE_FOLDERS.label,
    exact: PATHS.COLLABORATIVE_FOLDERS.exact,
    path: PATHS.COLLABORATIVE_FOLDERS.path,
    roles: [ROLES.ANALYST, ROLES.ORGANIZATION_ADMIN],
  },
];
